import styled from 'styled-components'

const MapStyler = styled.div``

export default MapStyler
